module.exports = __webpack_public_path__ + "img/save-blue.c29b126b.svg";